export default function futureFormSubmitted(state = false, action) {
  switch (action.type) {
    case 'FUTURE_FORM_SUBMITTED':
      return true
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/futureFormSubmitted.js